var thuringenQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Freistaat Thüringen?',
    image: '451',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 1,
      },
    ],
    category: 'Thüringen',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Thüringen?',
    answers: [
      {
        content: 'Ammerland',
        key: 0,
      },
      {
        content: 'Altötting',
        key: 0,
      },
      {
        content: 'Nordfriesland',
        key: 0,
      },
      {
        content: 'Wartburgkreis',
        key: 1,
      },
    ],
    category: 'Thüringen',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Thüringen gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Thüringen',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Thüringen bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 1,
      },
      {
        content: '18',
        key: 0,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Thüringen',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Thüringen?',
    answers: [
      {
        content: 'blau-weiß-rot',
        key: 0,
      },
      {
        content: 'weiß-rot',
        key: 1,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
      {
        content: 'schwarz-gold',
        key: 0,
      },
    ],
    category: 'Thüringen',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Thüringen über politische Themen informieren?',
    answers: [
      {
        content: 'bei den Kirchen',
        key: 0,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
    ],
    category: 'Thüringen',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Thüringen heißt...',
    answers: [
      {
        content: 'Eisenach.',
        key: 0,
      },
      {
        content: 'Erfurt.',
        key: 1,
      },
      {
        content: 'Gera.',
        key: 0,
      },
      {
        content: 'Jena.',
        key: 0,
      },
    ],
    category: 'Thüringen',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Thüringen?',
    image: '458',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 1,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Thüringen',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Thüringen?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Thüringen',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Thüringen nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Thüringen',
  },
]

export default thuringenQuestions
